<template>
  <div>
    <v-layout column class="mt-4 ml-4">
      <header-elements icon='mdi-glasses' @showUpload="showUpload=!showUpload" title='Reading Devices'></header-elements>
      <elements-table :items="all_devices" @showUpload="showUpload=!showUpload" title="Reading Device"></elements-table>

        <!-- <div class="mt-4 mb-3">
          <v-flex style="background-color:#f3f3f3;" class="px-3 py-1 elevation-0 xs12">
            <h3 class="subtitle xs12 flex">Reading Devices</h3>
          </v-flex>
        </div>       -->
        <!-- <v-flex xs12 sm12 md12 v-if="all_devices && all_devices.length>0">
          <v-list class="xs12">
            <v-list-tile v-for="e in all_devices" :key="e.id">
              <v-list-tile-title>
                <b>{{e.brand}}</b>
              </v-list-tile-title>
              <v-list-tile-title>Type & model: {{e.type_and_model}}</v-list-tile-title>
              <v-list-tile-title>Production Date: {{e.production_date}}</v-list-tile-title>
              <v-list-tile-action>
                <v-btn @click="done_reading_device" icon ><v-icon small>edit</v-icon></v-btn>
              </v-list-tile-action>
              <v-list-tile-action v-if="c_user.delete_rights">
                <v-btn @click="delete_reading_device" icon ><v-icon small>delete</v-icon></v-btn>
              </v-list-tile-action>
            </v-list-tile>
            <v-divider></v-divider>
          </v-list>
        </v-flex> -->

        <!-- <v-flex class="mr-5 pr-2 mt-0 mb-0 xs12" v-show="!showUpload">
          <v-btn icon class="mr-5 pr-2 right" @click="showUpload=!showUpload"><v-icon class="mr-2">add</v-icon> Add new Reading Device</v-btn>
        </v-flex> -->
        <!-- <v-btn icon class="mt-0 mb-0 xs12"  @click="showUpload=!showUpload"><v-icon>add</v-icon></v-btn> -->
          <!-- <v-btn icon class="mr-5 pr-2 right" @click="showUpload=!showUpload"><v-icon class="mr-2">add</v-icon> Add new Reading Device</v-btn> -->
        
        <v-card class="px-5 pt-4 elevation-5" v-if="showUpload">
          <v-container grid-list-xs fluid>
            <v-layout row wrap>

              <v-radio-group v-model="reading_device.category" label="Category" class="flex xs12 md6 mb-2">
                <v-radio v-for="s in constants.READING_DEVICE_TYPES" :label="s.name" :value="s.name" :key="s.id" class="ml-0"></v-radio>
              </v-radio-group>

              <v-flex v-if="(reading_device.category==='computer')">
                <v-radio-group v-model="reading_device.type" label="Sub-Category" class="flex xs12 md6 mb-2">
                  <v-radio v-for="s in constants.COMPUTERS" :label="s.name" :value="s.id" :key="s.id" class="ml-0"></v-radio>
                </v-radio-group>
              </v-flex>
              <v-flex v-if="(reading_device.category==='micro_controller')">
                <v-radio-group v-model="reading_device.type" label="Sub-Category" class="flex xs12 mb-2">
                  <v-radio v-for="s in constants.MICRO_CONTROLLERS" :label="s.name" :value="s.id" :key="s.id" class="ml-0"></v-radio>
                </v-radio-group>
              </v-flex>
              <v-flex v-if="(reading_device.category==='film_projector')">
                <v-radio-group v-model="reading_device.type" label="Sub-Category" class="flex xs12 mb-2">
                  <v-radio v-for="s in constants.FILM_PROJECTORS" :label="s.name" :value="s.id" :key="s.id" class="ml-0"></v-radio>
                </v-radio-group>
              </v-flex>
              <v-flex v-if="(reading_device.category==='slide_projector')">
                <v-radio-group v-model="reading_device.type" label="Sub-Category" class="flex xs12 mb-2">
                  <v-radio v-for="s in constants.SLIDE_PROJECTORS" :label="s.name" :value="s.id" :key="s.id" class="ml-0"></v-radio>
                </v-radio-group>
              </v-flex>
              <v-flex v-if="(reading_device.category==='video_tape_recorder')">
                <v-radio-group v-model="reading_device.type" label="Sub-Category" class="flex xs12 mb-2">
                  <v-radio v-for="s in constants.VIDEO_TAPE_RECORDERS" :label="s.name" :value="s.id" :key="s.id" class="ml-0"></v-radio>
                </v-radio-group>
              </v-flex>
              <!-- <v-flex v-if="(reading_device.category==='linear_tape_drive')">
                <v-radio-group v-model="reading_device.type" label="Sub-Category" class="flex xs12 mb-2">
                  <v-radio v-for="s in this.$store.state.linear_tape_drives" :label="s.name" :value="s.id" :key="s.id" class="ml-0"></v-radio>
                </v-radio-group>
              </v-flex>
              <v-flex v-if="(reading_device.category==='disc_tape_drive')">
                <v-radio-group v-model="reading_device.type" label="Sub-Category" class="flex xs12 mb-2">
                  <v-radio v-for="s in this.$store.state.disc_tape_drives" :label="s.name" :value="s.id" :key="s.id" class="ml-0"></v-radio>
                </v-radio-group>
              </v-flex>
              <v-flex v-if="(reading_device.category==='dvd_player')">
                <v-radio-group v-model="reading_device.type" label="Sub-Category" class="flex xs12 mb-2">
                  <v-radio v-for="s in this.$store.state.dvd_players" :label="s.name" :value="s.id" :key="s.id" class="ml-0"></v-radio>
                </v-radio-group>
              </v-flex>
              <v-flex v-if="(reading_device.category==='media_player')">
                <v-radio-group v-model="reading_device.type" label="Sub-Category" class="flex xs12 mb-2">
                  <v-radio v-for="s in this.$store.state.media_players" :label="s.name" :value="s.id" :key="s.id" class="ml-0"></v-radio>
                </v-radio-group>
              </v-flex> -->
              <v-flex v-if="(reading_device.category==='other')">
                <v-text-field v-model="reading_device.other" label="Other"></v-text-field>
              </v-flex>

              <v-flex class="xs12 md6 pr-3">
                <v-text-field v-model="reading_device.brand" label="Brand"></v-text-field>
              </v-flex>
              <v-flex class="xs12 md6">
                <v-text-field v-model="reading_device.type_and_model" label="Type and Model"></v-text-field>
              </v-flex>
              <v-flex xs12>
                <h4 class='body-2'>Date of Production</h4>
                <v-date-picker landscape label="Accession Date" v-model="reading_device.production_date"></v-date-picker>
              </v-flex>
              <v-flex class="xs12 mt-5 mb-4">
                <h4 class='body-2'>Interfaces</h4>
                <!-- <v-radio-group v-model="reading_device.interfaces" label="Interfaces" class="flex xs12 mb-2"> -->
                <template>
                  <v-container class="py-0 px-0 mx-0 my-0" grid-list-md text-xs-center>
                    <v-layout row wrap>
                      <v-flex xs6 sm4 md3 py-0 v-for="s in constants.INTERFACES" :key="s.id" >
                        <v-checkbox v-model="reading_device.interfaces" hide-details :label="s.name" :value="s.id" class="ml-0 px-0"></v-checkbox>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </template>
                <!-- </v-radio-group> -->
                <!-- <v-textarea rows=1 auto-grow v-model="reading_device.ionterfaces" label="Interfaces"></v-textarea> -->
              </v-flex>
              <v-flex class="xs12 md6 pr-3">
                <v-text-field v-model="reading_device.number_of_parts" label="Number of Parts"></v-text-field>
              </v-flex>
              <v-flex class="xs12 md6">
                <v-textarea rows=1 auto-grow v-model="reading_device.power_requirement" label="Power Requirement"></v-textarea>
              </v-flex>
              <v-flex class="xs12">
                <v-textarea rows=1 auto-grow v-model="reading_device.installation_specifications" label="Specifications on installation"></v-textarea>
              </v-flex>
              <v-flex class="xs12">
                <v-textarea rows=1 auto-grow v-model="reading_device.modification" label="Modification"></v-textarea>
              </v-flex>
              <v-flex class="xs12">
                <v-textarea rows=1 auto-grow v-model="reading_device.periphals" label="Periphals"></v-textarea>
              </v-flex>
              <v-flex class="xs12">
                <v-textarea rows=1 auto-grow v-model="reading_device.associated_items" label="Associated items"></v-textarea>
              </v-flex>
              <v-flex class="xs12 md3 pr-3">
                <v-text-field v-model="reading_device.height" suffix="cm" label="Height"></v-text-field>
              </v-flex>
              <v-flex class="xs12 md3 pr-3">
                <v-text-field v-model="reading_device.width" suffix="cm" label="Width"></v-text-field>
              </v-flex>
              <v-flex class="xs12 md3 pr-3">
                <v-text-field v-model="reading_device.depth" suffix="cm" label="Depth"></v-text-field>
              </v-flex>
              <v-flex class="xs12 md3">
                <v-text-field v-model="reading_device.weight" suffix="cm" label="Weight"></v-text-field>
              </v-flex>

            </v-layout>
          </v-container>
          <v-flex class="xs12 ml-3 mb-3">
            <v-btn @click="save_reading_device">save</v-btn>
            <v-btn @click="showUpload=!showUpload">cancel</v-btn>
          </v-flex>
        </v-card>

    </v-layout>
  </div>
</template>

<script>
  // import EditFieldSub from './EditFieldSub'
  import HeaderElements from './HeaderElements'
  import ElementsTable from './ElementsTable'

  export default {
    props: ['artwork','field'],
    data: () => ({
      reading_device: {
        name: ''
      },
      reading_devices: [
      ],
      // categories: ['computer','micro_controller','film_projector','slide_projector', 'video_tape_recorder', 'linear_tape_drive','disc_tape_drive','dvd_player','media_player','other'],
      // fields: [
        // {
        //   'ctype': 'radio',
        //   'selection': [{id: 1, name: 'monitor'},{id:2, name:'projector'},{id:3, name:'motor'}, {id:4, name:'bulb'}, {id:5, name:'switch'}],
        //   'name': 'category',
        //   'title': 'Category',
        //   column: false,
        //   class: 'xs12',
        //   work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        //   user_groups: ['admin', 'manager']
        // },
        // {
        //   ctype: 'text-long',
        //   name: 'brand',
        //   title: 'Brand',
        //   work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        //   user_groups: ['admin', 'manager']
        // },
        // {
        //   ctype: 'text-long',
        //   name: 'type_and_model',
        //   title: 'Type and Model',
        //   work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        //   user_groups: ['admin', 'manager']
        // },
        // {
        //   ctype: 'date',
        //   name: 'production_date',
        //   title: 'Date of Production',
        //   work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        //   user_groups: ['admin', 'manager']
        // },
        // {
        //   name: 'headline_fields',
        //   headline: true,
        //   section: 'fields',
        //   title: 'Basic',
        //   work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        //   user_rights: ['admin', 'manager']
        // },
        // {
        //   ctype: 'radio',
        //   name: 'computer',
        //   title: 'Computer',
        //   dynamic: true,
        //   section: 'fields',
        //   selection: [{id: 1, name:'Server'},{id: 2, name:'Laptop'},{id: 3, name:'Desktop'},{id: 4, name:'Virtual'},{id: 5, name:'Other'}],
        //   work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        //   user_groups: ['admin', 'manager']
        // },
        // {
        //   ctype: 'radio',
        //   name: 'micro_controller',
        //   title: 'Micro Controller',
        //   dynamic: true,
        //   section: 'fields',
        //   selection: [{id: 1, name:'LCD'},{id: 2, name:'LED-LCD'},{id: 3, name:'Plasma'},{id: 4, name:'Other'}],
        //   work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        //   user_groups: ['admin', 'manager']
        // },
        // {
        //   ctype: 'radio',
        //   name: 'film_projector',
        //   title: 'Film Projector',
        //   dynamic: true,
        //   section: 'fields',
        //   selection: [{id: 1, name:'8 mm'},{id: 2, name:'16mm'},{id: 3, name:'35mm'},{id: 4, name:'Other'}],
        //   work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        //   user_groups: ['admin', 'manager']
        // },
        // {
        //   ctype: 'radio',
        //   name: 'slide_projector',
        //   title: 'Slide Projector',
        //   dynamic: true,
        //   section: 'fields',
        //   selection: [{id: 1, name:'Single projecting'},{id: 2, name:'Slate'},{id: 3, name:'Carousel'},{id: 4, name:'Other'}],
        //   work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        //   user_groups: ['admin', 'manager']
        // },
        // {
        //   ctype: 'radio',
        //   name: 'video_tape_recorder',
        //   title: 'Video Tape Recorder',
        //   dynamic: true,
        //   section: 'fields',
        //   selection: ['Open Reel (1/2“)','Umatic','Betacam/SP','VHS','Digital Betacam','DV  (1/4“)','HDCAM','Other'],
        //   work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        //   user_groups: ['admin', 'manager']
        // },
        // {
        //   ctype: 'bool',
        //   name: 'linear_tape_drive',
        //   title: 'Linear Tape Drive',
        //   dynamic: true,
        //   section: 'fields',
        //   work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        //   user_groups: ['admin', 'manager']
        // },
      //   {
      //     ctype: 'bool',
      //     name: 'floppy',
      //     title: 'Disc Tape Drive (Floppy)',
      //     dynamic: true,
      //     section: 'fields',
      //     work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
      //     user_groups: ['admin', 'manager']
      //   },
      //   {
      //     ctype: 'bool',
      //     name: 'dvd_player',
      //     title: 'DVD Player',
      //     dynamic: true,
      //     section: 'fields',
      //     work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
      //     user_groups: ['admin', 'manager']
      //   },
      //   {
      //     ctype: 'bool',
      //     name: 'media_player',
      //     title: 'Media player',
      //     dynamic: true,
      //     section: 'fields',
      //     work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
      //     user_groups: ['admin', 'manager']
      //   },
      //   {
      //     ctype: 'text-long',
      //     name: 'other_player',
      //     title: 'Other',
      //     dynamic: true,
      //     section: 'fields',
      //     selection: ['Server','Laptop','Desktop','Virtual','Other'],
      //     work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
      //     user_groups: ['admin', 'manager']
      //   },
      //   {
      //     name: 'headline_brand',
      //     headline: true,
      //     section: 'brand',
      //     title: 'Details',
      //     work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
      //     user_rights: ['admin', 'manager']
      //   },
      //   {
      //     ctype: 'checkbox',
      //     name: 'interfaces',
      //     title: 'Interfaces',
      //     dynamic: true,
      //     section: 'brand',
      //     selection: ['composite','component','SVideo','SDI','VGA','HDMI','DVI','IDE','SATA','USB 2.0','USB 3.0','FireWire','Thunderbolt','XLR Audio','unknown','other'],
      //     work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
      //     user_groups: ['admin', 'manager']
      //   },
      //   {
      //     ctype: 'text-long',
      //     name: 'input_output',
      //     title: 'Input - Output',
      //     dynamic: true,
      //     section: 'brand',
      //     work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
      //     user_groups: ['admin', 'manager']
      //   },
      //   {
      //     ctype: 'text-short',
      //     name: 'power-requirement',
      //     title: 'Power Requirement',
      //     dynamic: true,
      //     class: 'xs12 md6',
      //     section: 'brand',
      //     work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
      //     user_groups: ['admin', 'manager']
      //   },
      //   {
      //     ctype: 'text-long',
      //     name: 'cooling_system',
      //     title: 'Cooling system',
      //     dynamic: true,
      //     section: 'brand',
      //     work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
      //     user_groups: ['admin', 'manager']
      //   },
      //   {
      //     ctype: 'text-short',
      //     name: 'number_of_parts',
      //     title: 'Number of Parts',
      //     dynamic: true,
      //     section: 'brand',
      //     class: 'xs12 md6',
      //     work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
      //     user_groups: ['admin', 'manager']
      //   },
      //   {
      //     ctype: 'text-long',
      //     name: 'specification_of_parts',
      //     title: 'Specification of parts',
      //     dynamic: true,
      //     section: 'brand',
      //     work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
      //     user_groups: ['admin', 'manager']
      //   },
      //   {
      //     ctype: 'text-long',
      //     name: 'dimensions',
      //     title: 'Dimensions (cm) and weight',
      //     dynamic: true,
      //     section: 'brand',
      //     work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
      //     user_groups: ['admin', 'manager']
      //   },
      //   {
      //     ctype: 'text-long',
      //     name: 'modification',
      //     title: 'Modification',
      //     dynamic: true,
      //     section: 'brand',
      //     work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
      //     user_groups: ['admin', 'manager']
      //   },
      //   {
      //     ctype: 'text-long',
      //     name: 'installation_specification',
      //     title: 'Specifications on installation',
      //     dynamic: true,
      //     section: 'brand',
      //     work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
      //     user_groups: ['admin', 'manager']
      //   },
      //   {
      //     ctype: 'text-long',
      //     name: 'peripherals',
      //     title: 'Peripherals',
      //     dynamic: true,
      //     section: 'brand',
      //     work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
      //     user_groups: ['admin', 'manager']
      //   },
      //   {
      //     ctype: 'text-long',
      //     name: 'associated_items',
      //     title: 'Associated items',
      //     dynamic: true,
      //     section: 'brand',
      //     work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
      //     user_groups: ['admin', 'manager']
      //   },
      //   {
      //     ctype: 'text-long',
      //     name: 'provided_spare_parts',
      //     title: 'Provided spare parts',
      //     dynamic: true,
      //     section: 'brand',
      //     work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
      //     user_groups: ['admin', 'manager']
      //   }
      // ],
      showUpload: false,
      show: false,
      showme: false,
      reading_device: {
        category: '',
        monitor_specification: '',
        projector_specification: '',
        motor_specification: '',
        bulb_specification: '',
        switch: '',
        other: '',
        monitor_origin: '',
        projector_origin: '',
        motor_origin: '',
        bulb_origin: '',
        switch_origin: '',
        other_origin: '',
        interfaces: '',
        brand: '',
        sn: '',
        an: '',
        production_date: '',
        number_of_parts: '',
        power_requirement: '',
        height: '',
        width: '',
        depth: '',
        weight: '',
        specs: '',
        modification: '',
        periphals: '',
        associated_items: ''
      }
    }),
    computed: {
      all_devices () {
        return this.$store.state.reading_devices
        // console.log(todos)
        // return todos
      },      // c () {
      //   return this.showme
      // }
    },
    methods: {
      // show_field (f) {
      //   if (f.condition) {
      //     this.showme = true
      //     var a = f.condition
      //     // console.log(a)
      //     return eval(a)
      //   } else {
      //     return true
      //   }
        // return Function('"use strict";return (a)')()
      // },
      download () {},
      // add () {
      //   this.reading_device.push(this.reading_device)
      //   this.showUpload=!this.showUpload
      // },
      delete_reading_device () {},
      done_reading_device () {},
      save_reading_device () {
        this.reading_device.artwork_id = this.artwork.id
        this.reading_device.done = false
        this.reading_device.id = this.findMinMax(this.all_devices)+1
        this.$store.commit('ADD_READING_DEVICE', this.reading_device)
        // this.all_reading_device.push(this.reading_device)
        this.showUpload=!this.showUpload
        this.reading_device = {
          description: '',
          title: '',
          deadline: '',
          done: false
        }
        // var areading_device = Object.keys(this.reading_device).forEach(k => this.reading_device[k]='')
        // console.log(areading_device)
      },
      findMinMax(arr) {
        if (arr===undefined || arr.length===0) {
          return 1
        } else {
          let max = arr[0].id
          for (let i = 1, len=arr.length; i < len; i++) {
            let v = arr[i].id
            max = (v > max) ? v : max
          }
          // console.log(max)
          return max
        }
      }
    },
    components: {HeaderElements,ElementsTable}
  }
</script>

<style scoped>
/* .card { min-width:250px;} */
</style>



// WEBPACK FOOTER //
// src/components/artworks/ReadingDevices.vue